/* istanbul ignore file */
import React from 'react'
import styled from 'styled-components'
import PlaceholderContainer from 'commons/js/ui/PlaceholderContainer'
import { themeColor, Box } from '@elparking/components'

const PlaceholderImage = styled.img`
    max-width: 100%;
    background-color: ${themeColor('white')};
    margin-left: -12px;
    margin-bottom: 16px;
`

const RentalCarContractProcessCompactPlaceholder = () => (
    <Box mt='1em' mr={['0em', '1em']} width='100%'>
        <PlaceholderContainer>
            <PlaceholderImage src='/images/booking-process/booking-detail-compact-placeholder.svg' />
        </PlaceholderContainer>
    </Box>
)
export default RentalCarContractProcessCompactPlaceholder
